export const social = [
  {
    url: 'https://t.me/interesnee_ru',
    id: 'tg',
    width: '22',
    height: '18',
  },
  {
    url: 'https://vk.com/interesnee_ru',
    id: 'vk',
    width: '22',
    height: '13',
  },
  // {
  //   url: 'https://www.linkedin.com/company/interesnee-ru/',
  //   id: 'linked-in',
  //   width: '18',
  //   height: '18',
  // },
];

export const addresses = [
  {
    url:
      "https://www.google.com/maps/place/Krasnyy+Pereulok,+5%2F1,+Yekaterinburg,+Sverdlovskaya+oblast',+620027/@56.8500395,60.594711,17z/data=!3m1!4b1!4m5!3m4!1s0x43c16e65a47646f7:0x67c944d123bc3eb3!8m2!3d56.8500395!4d60.5968997",
    city: 'Россия, Екатеринбург',
    link: '/company/ekaterinburg',
    text: 'пер. Красный, д. 5/1',
    country: '/static/flags/rus.svg',
    location: true,
  },
  {
    url: 'https://goo.gl/maps/zjoLkPpk86YnWuMt9',
    city: 'Россия, Сочи',
    link: '/company/sochi',
    text: 'ул. Невская, 23',
    country: '/static/flags/rus.svg',
    location: true,
  },
  {
    url:
      'https://www.google.com/maps/place/Ulitsa+Krasnoy+Armii,+10+строение+5,+Krasnoyarsk,+Krasnoyarskiy+kray,+660060/@56.0140894,92.8556513,17z',
    city: 'Россия, Красноярск',
    link: '/company/krasnoyarsk',
    text: 'ул. Красной армии, д. 10/5',
    country: '/static/flags/rus.svg',
    location: true,
  },
  /*{
    url: 'https://maps.app.goo.gl/HnMBq97oQGtJdh2F6',
    city: 'Казахстан, г. Рудный',
    text: 'ул. Горняков, 70, оф. 422',
    country: '/static/flags/kaz.svg',
    location: true,
  },
  {
    url: 'https://maps.app.goo.gl/mUh8chAVG3zMdbMq9',
    city: 'Vietnam, Ho Chi Minh',
    text: `7th floor, L’Mak Long Tower, 101 – 103 Nguyen Cuu Van Street, Ward 17, Binh Thanh District`,
    country: '/static/flags/vnm.svg',
    location: true,
  },*/
];

export const offices = [
  {
    images: [
      {
        origin: '/images/photos/offices/ekaterinburg/ekaterinburg-1.jpg',
        placeholder:
          '/images/photos/offices/ekaterinburg/ekaterinburg-1@placeholder.jpg',
        webp: '/images/photos/offices/ekaterinburg/ekaterinburg-1.webp',
      },
    ],
    city: 'Екатеринбург',
    link: '/company/ekaterinburg',
    address: 'пер. Красный, д. 5/1',
    value: 'ekb',
  },
  {
    images: [
      {
        origin: '/images/photos/offices/rydniy/rydniy-1.jpg',
        placeholder: '/images/photos/offices/rydniy/rydniy-1@placeholder.jpg',
      },
    ],
    city: 'Рудный',
    address: 'ул. Горняков, 70, оф. 413',
    value: 'rdn',
  },
  {
    images: [
      {
        origin: '/images/photos/offices/krasnoyarsk/krasnoyarsk-8.jpg',
        placeholder:
          '/images/photos/offices/krasnoyarsk/krasnoyarsk-8@placeholder.jpg',
        webp: '/images/photos/offices/krasnoyarsk/krasnoyarsk-8.webp',
      },
      {
        origin: '/images/photos/offices/krasnoyarsk/krasnoyarsk-1.jpg',
        placeholder:
          '/images/photos/offices/krasnoyarsk/krasnoyarsk-1@placeholder.jpg',
        webp: '/images/photos/offices/krasnoyarsk/krasnoyarsk-1.webp',
      },
      {
        origin: '/images/photos/offices/krasnoyarsk/krasnoyarsk-2.jpg',
        placeholder:
          '/images/photos/offices/krasnoyarsk/krasnoyarsk-2@placeholder.jpg',
        webp: '/images/photos/offices/krasnoyarsk/krasnoyarsk-2.webp',
      },
      {
        origin: '/images/photos/offices/krasnoyarsk/krasnoyarsk-3.jpg',
        placeholder:
          '/images/photos/offices/krasnoyarsk/krasnoyarsk-3@placeholder.jpg',
        webp: '/images/photos/offices/krasnoyarsk/krasnoyarsk-3.webp',
      },
      {
        origin: '/images/photos/offices/krasnoyarsk/krasnoyarsk-4.jpg',
        placeholder:
          '/images/photos/offices/krasnoyarsk/krasnoyarsk-4@placeholder.jpg',
        webp: '/images/photos/offices/krasnoyarsk/krasnoyarsk-4.webp',
      },
      {
        origin: '/images/photos/offices/krasnoyarsk/krasnoyarsk-5.jpg',
        placeholder:
          '/images/photos/offices/krasnoyarsk/krasnoyarsk-5@placeholder.jpg',
        webp: '/images/photos/offices/krasnoyarsk/krasnoyarsk-5.webp',
      },
      {
        origin: '/images/photos/offices/krasnoyarsk/krasnoyarsk-6.jpg',
        placeholder:
          '/images/photos/offices/krasnoyarsk/krasnoyarsk-6@placeholder.jpg',
        webp: '/images/photos/offices/krasnoyarsk/krasnoyarsk-6.webp',
      },
      {
        origin: '/images/photos/offices/krasnoyarsk/krasnoyarsk-7.jpg',
        placeholder:
          '/images/photos/offices/krasnoyarsk/krasnoyarsk-7@placeholder.jpg',
        webp: '/images/photos/offices/krasnoyarsk/krasnoyarsk-7.webp',
      },
    ],
    city: 'Красноярск',
    link: '/company/krasnoyarsk',
    address: 'ул. Красной армии, д.10/5',
    value: 'ksk',
  },
  {
    images: [
      {
        origin: '/images/photos/offices/sochi/Image-1.jpg',
        placeholder: '/images/photos/offices/sochi/Image-1.min.jpg',
        webp: '/images/photos/offices/sochi/image-1.webp',
      },
      {
        origin: '/images/photos/offices/sochi/Image-2.jpg',
        placeholder: '/images/photos/offices/sochi/Image-2.min.jpg',
        webp: '/images/photos/offices/sochi/image-2.webp',
      },
      {
        origin: '/images/photos/offices/sochi/Image-3.jpg',
        placeholder: '/images/photos/offices/sochi/Image-3.min.jpg',
        webp: '/images/photos/offices/sochi/image-3.webp',
      },
      {
        origin: '/images/photos/offices/sochi/Image-4.jpg',
        placeholder: '/images/photos/offices/sochi/Image-4.min.jpg',
        webp: '/images/photos/offices/sochi/image-4.webp',
      },
    ],
    link: '/company/sochi',
    city: 'Сочи',
    address: 'ул. Невская, 23',
    value: 'sch',
  },
  {
    images: [
      {
        origin: '/images/photos/offices/new-york/new-york-1.jpg',
        placeholder:
          '/images/photos/offices/new-york/new-york-1@placeholder.jpg',
        webp: '/images/photos/offices/new-york/new-york-1.webp',
      },
    ],
    city: 'New York',
    address: '222 Broadway, New York, NY. 10038, 19th Floor',
    value: 'ny',
  },
  {
    images: [
      {
        origin: '/images/photos/offices/newport-beach/newport-beach-1.jpg',
        placeholder:
          '/images/photos/offices/newport-beach/newport-beach-1@placeholder.jpg',
        webp: '/images/photos/offices/newport-beach/newport-beach-1.webp',
      },
      {
        origin: '/images/photos/offices/newport-beach/newport-beach-2.jpg',
        placeholder:
          '/images/photos/offices/newport-beach/newport-beach-2@placeholder.jpg',
        webp: '/images/photos/offices/newport-beach/newport-beach-2.webp',
      },
      {
        origin: '/images/photos/offices/newport-beach/newport-beach-3.jpg',
        placeholder:
          '/images/photos/offices/newport-beach/newport-beach-3@placeholder.jpg',
        webp: '/images/photos/offices/newport-beach/newport-beach-3.webp',
      },
      {
        origin: '/images/photos/offices/newport-beach/newport-beach-4.jpg',
        placeholder:
          '/images/photos/offices/newport-beach/newport-beach-4@placeholder.jpg',
        webp: '/images/photos/offices/newport-beach/newport-beach-4.webp',
      },
      {
        origin: '/images/photos/offices/newport-beach/newport-beach-5.jpg',
        placeholder:
          '/images/photos/offices/newport-beach/newport-beach-5@placeholder.jpg',
        webp: '/images/photos/offices/newport-beach/newport-beach-5.webp',
      },
      {
        origin: '/images/photos/offices/newport-beach/newport-beach-6.jpg',
        placeholder:
          '/images/photos/offices/newport-beach/newport-beach-6@placeholder.jpg',
        webp: '/images/photos/offices/newport-beach/newport-beach-6.webp',
      },
      {
        origin: '/images/photos/offices/newport-beach/newport-beach-7.jpg',
        placeholder:
          '/images/photos/offices/newport-beach/newport-beach-7@placeholder.jpg',
        webp: '/images/photos/offices/newport-beach/newport-beach-7.webp',
      },
      {
        origin: '/images/photos/offices/newport-beach/newport-beach-8.jpg',
        placeholder:
          '/images/photos/offices/newport-beach/newport-beach-8@placeholder.jpg',
        webp: '/images/photos/offices/newport-beach/newport-beach-8.webp',
      },
      {
        origin: '/images/photos/offices/newport-beach/newport-beach-9.jpg',
        placeholder:
          '/images/photos/offices/newport-beach/newport-beach-9@placeholder.jpg',
        webp: '/images/photos/offices/newport-beach/newport-beach-9.webp',
      },
    ],
    city: 'Newport Beach',
    address:
      '20411 Birch St., Suite 330, Newport Beach, Orange County, CA, 92660',
    value: 'nb',
  },
  {
    images: [
      {
        origin: '/images/photos/offices/chicago/chicago-1.jpg',
        placeholder: '/images/photos/offices/chicago/chicago-1@placeholder.jpg',
        webp: '/images/photos/offices/chicago/chicago-1.webp',
      },
    ],
    city: 'Chicago',
    address: 'USA, 111 W Illinois St,\nChicago, IL, 60654',
    value: 'ch',
  },
  {
    images: [
      {
        origin: '/images/photos/offices/vietnam/vietnam-1.jpg',
        placeholder: '/images/photos/offices/vietnam/vietnam-1@placeholder.jpg',
        webp: '/images/photos/offices/vietnam/vietnam-1.webp',
      },
      {
        origin: '/images/photos/offices/vietnam/vietnam-2.jpg',
        placeholder: '/images/photos/offices/vietnam/vietnam-2@placeholder.jpg',
        webp: '/images/photos/offices/vietnam/vietnam-2.webp',
      },
      {
        origin: '/images/photos/offices/vietnam/vietnam-3.jpg',
        placeholder: '/images/photos/offices/vietnam/vietnam-3@placeholder.jpg',
        webp: '/images/photos/offices/vietnam/vietnam-3.webp',
      },
      {
        origin: '/images/photos/offices/vietnam/vietnam-4.jpg',
        placeholder: '/images/photos/offices/vietnam/vietnam-4@placeholder.jpg',
        webp: '/images/photos/offices/vietnam/vietnam-4.webp',
      },
      {
        origin: '/images/photos/offices/vietnam/vietnam-5.jpeg',
        placeholder: '/images/photos/offices/vietnam/vietnam-5@placeholder.jpg',
        webp: '/images/photos/offices/vietnam/vietnam-5.webp',
      },
      {
        origin: '/images/photos/offices/vietnam/vietnam-7.jpg',
        placeholder: '/images/photos/offices/vietnam/vietnam-7@placeholder.jpg',
        webp: '/images/photos/offices/vietnam/vietnam-7.webp',
      },
      {
        origin: '/images/photos/offices/vietnam/vietnam-8.jpg',
        placeholder: '/images/photos/offices/vietnam/vietnam-8@placeholder.jpg',
        webp: '/images/photos/offices/vietnam/vietnam-8.webp',
      },
      {
        origin: '/images/photos/offices/vietnam/vietnam-9.jpg',
        placeholder: '/images/photos/offices/vietnam/vietnam-9@placeholder.jpg',
        webp: '/images/photos/offices/vietnam/vietnam-9.webp',
      },
    ],
    city: 'Ho Chi Minh',
    address: `7th floor, L’Mak Long Tower, 101 – 103 Nguyen Cuu Van Street, Ward 17, Binh Thanh District`,
    value: 'hcm',
  },
];

export const mainPhone = {
  label: '+7 (908) 221-31-04',
  link: 'tel:+79082213104',
};

export const contacts = [
  {
    title: 'hr@interesnee.ru',
    value: 'mailto:hr@interesnee.ru',
  },
  {
    title: 'Красноярск',
    value: mainPhone.link,
  },
  {
    title: 'Екатеринбург',
    value: mainPhone.link,
  },
  {
    title: 'Сочи',
    value: mainPhone.link,
  },
];



// WEBPACK FOOTER //
// ./src/data/mockCommonInfo.js